// extracted by mini-css-extract-plugin
export default {"extraFieldsWrapper":"extraFieldsWrapper__5OgQC","extraFieldsExpanded":"extraFieldsExpanded__38u8m"};